import { defineMessages } from 'react-intl';

export default defineMessages({
  pullRequestHeaderLabel: {
    id: 'frontbucket.repository.pullRequest.header.label',
    description: 'Label for the header of the pull request page',
    defaultMessage: 'Pull request header',
  },
  pullRequestSummary: {
    id: 'frontbucket.repository.pullRequest.header.pullRequestSummary',
    description:
      'Text describing the pull request: the ID, and how recently it was updated',
    defaultMessage: '#{id} Created {created} Last updated {updated}',
  },
});
